export default {
  index: [
    {
      path: '/gwqytype',
      component: resolve => require(['./gw_qytypeIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/gw_qytype/_router.js